/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import OpportunityForm from "../../components/OpportunityForm";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import { GET_USER_INFO } from "../../utils/constants";

function ParsingForm() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const [hasSavedResume, setHasSavedResume] = useState(false);
  const [isCheckingResume, setIsCheckingResume] = useState(true);

  useEffect(() => {
    if (
      localStorage.getItem('token') === null ||
      localStorage.getItem('token') === undefined
    ) {
      navigate('/login');
      return;
    }
    document.title = 'Career Discovery - Nclude Portal';

    const isNewRoute = location.pathname.includes('/opportunity/new');
    if (!isNewRoute && localStorage.getItem("resume") === "true") {
      navigate('/opportunity/chatbot', { replace: true, state: { useResumeContext: true } });
      return;
    }

    let isCurrent = true;
    const checkSavedResume = async () => {
      try {
        const resp = await makeAuthenticatedGet(GET_USER_INFO);
        if (!isCurrent) return;
        const hasResume = Boolean(resp?.success && resp?.user?.resume);
        if (hasResume) {
          localStorage.setItem("resume", "true");
          setHasSavedResume(true);
          if (!isNewRoute) {
            navigate('/opportunity/chatbot', { replace: true, state: { useResumeContext: true } });
            return;
          }
        } else {
          localStorage.setItem("resume", "false");
          setHasSavedResume(false);
        }
      } catch (error) {
        if (!isCurrent) return;
        if (localStorage.getItem("resume") === "true") {
          setHasSavedResume(true);
          if (!isNewRoute) {
            navigate('/opportunity/chatbot', { replace: true, state: { useResumeContext: true } });
            return;
          }
        }
      } finally {
        if (isCurrent) setIsCheckingResume(false);
      }
    };

    checkSavedResume();
    return () => {
      isCurrent = false;
    };
  }, [navigate, location.pathname]);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="Opportunity"/>
        <main className="doc-container" id="main-content" tabIndex={-1}>
          <h1 className="display-title" ref={mainRef} tabIndex={-1}>{"Career discovery"}</h1>
          <p style={{ fontSize: "0.875rem", color: "#6c757d", marginTop: "0.25rem", marginBottom: "0.5rem" }} role="status" aria-live="polite">
            Agent status: Online
          </p>
          <p className="accessibility-helper">Thanks for your interest in career insights based on lived experiences of people with disabilities. It will be helpful if we can start with your resume if you have one readily available. That way, I can already learn a lot about you.</p>
          {isCheckingResume && <p className="resume-profile-status" role="status">Checking your profile for a saved resume…</p>}
          {!isCheckingResume && hasSavedResume && (
            <p className="resume-profile-status" role="status">
              A saved resume is available in your profile. You can continue with it or upload a newer resume.
            </p>
          )}
          <div className="component-container form-container">
            <OpportunityForm hasSavedResume={hasSavedResume} />
          </div>
        </main>
      </div>
    </div>
  );
}

export default ParsingForm;
